import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {FormGroup, FormBuilder, Validators, AbstractControl} from '@angular/forms';
import {Consultant} from '../../../models/Consultant.model';
import {ConsultantService} from '../../../services/consultant.service';
import {CnaeService} from '../../../services/cnae.service';
import { AwsService } from '../../../services/aws.service';
import { CnpjService } from '../../../services/cnpj.service';
import {CommonHelper} from '../../../shared/helpers/CommonHelper';
import {UserService} from '../../../services/user.service';
import { BankService } from '../../../services/bank.service';
import {Responsible} from '../../../models/Responsible.model';
import {ContractType} from '../../../shared/enums/ContractType';
import {Router} from '@angular/router';
import {HonorariumType} from '../../../shared/enums/HonorariumType';
import {ToastsManager} from 'ng2-toastr';
import {ConsultantSearch} from "../../../models/ConsultantSearch.model";
import { PixKeyType } from '../../../shared/enums/PixKeyType';

import { CompanyService } from '../../../services/billing-letter/company.service';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { SapItemType } from '../../../shared/enums/SapItemType';

import * as moment from 'moment';
import * as _ from 'lodash';
import { CompaniesService } from '../../../services/companies.service';
import { PixValidation } from '../../../shared/helpers/PixValidation';
import { PublicConsultantService } from "../../../services/public-consultant.service";
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';
import { ExcellenceCenter } from "../../../models/ExcellenceCenter.model";

@Component({
    selector: 'app-consultant-create',
    templateUrl: './consultant-create.component.html',
    styleUrls: ['./consultant-create.component.css']
})
export class ConsultantCreateComponent implements OnInit {
    @ViewChild('uploadInput') uploadInput:ElementRef;
    emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    emailPatternFC = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    cpfPattern = /^([0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2})$/i;
    consultantForm: FormGroup;
    mask = [/[0-3]/,/[0-9]/,'/',/[0-1]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/]
    accountMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,] ;
    agencyMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/] ;
    digitMask = [/[A-Za-z0-9]/];
    bankCodeMask = [/[0-9]/,/[0-9]/,/[0-9]/];
    consultantSearch = new ConsultantSearch();
    consultant: Consultant = new Consultant();
    commonHelper: CommonHelper = new CommonHelper();
    responsibles: Responsible[] = new Array<Responsible>();
    bps: Responsible[] = new Array<Responsible>();
    options: any;
    honorarium: Boolean;
    showSoldHoursValue: Boolean;
    showHourValue: boolean = false;
    showTotalValue: boolean = false;
    showMensalHours: boolean = false;
    disableHourValue: boolean = false;
    errors = [];
    selectedFiles:FileList;
    chequePayment = true;
    customers: any = [];
    skills: any = [];
    customersDropdown = { list: [], options: null, selected: [] };
    skillsDropdown = { list: [], options: null, selected: [] };
    loading;
    cnaes = [];
    occupations = [];
    banks : any = [];
    bankForEdit: any = [];
    bankCode: Number;
    bankName: string;
    bankCountry: string;
    pixKeyVerifyMethod : any;
    pixKeyFlag: Boolean = true;
    pixCpfValid : Boolean;
    pixCnpjValid : Boolean;
    phoneMaskFlag: Boolean = false;
    textMask;
    showHourValueBenefits: boolean = false;
    excellenceCenters: Array<ExcellenceCenter> = [];
    supportCenters: Array<ExcellenceCenter> = [];
    allCenters: Array<ExcellenceCenter> = [];

    constructor(public consultantService: ConsultantService,
                private userService: UserService,
                private awsService: AwsService,
                private cnpjService: CnpjService,
                private router: Router,
                private formBuilder: FormBuilder,
                private toastr: ToastsManager,
                private companyService: CompanyService,
                private companiesService: CompaniesService,
                private dropDownItemFactory: DropdownItemFactory,
                private dropDownSettingFactory: DropdownSettingsFactory,
                private cnaeService: CnaeService,
                private bankService: BankService,
                public pixValidation: PixValidation,
                private publicConsultantService: PublicConsultantService,
                private excellenceCentersService: ExcellenceCentersService,
            ) {
    }

    async ngOnInit() {
        this.loading = true;
        this.options = this.commonHelper.getDatePickerOptions();
        this.consultantForm = this.formBuilder.group({
            name: [null, Validators.required],
            begin:[null, Validators.required],
            email: [null, [Validators.email]],
            fcEmail: [null, [Validators.required, Validators.email]],
            contractKind: [null, [this.validateSelectOption]],
            rg: [null, [Validators.required]],
            cpf: [null, [Validators.required, Validators.pattern(this.cpfPattern)]],
            sex: [null, [this.validateSelectOption]],
            civilStatus: [null, [this.validateSelectOption]],
            cep: [null, null],
            address: [null,null],
            number: [null, null],
            district: [null, null],
            city: [null, null],
            state: [null,null],
            responsible: [null, [this.validateSelectOptionResponsible]],
            bp: [null, [this.validateSelectOptionBP]],
            pixType: [null, null],
            keyPix:[null,[this.validateKeyPix]],
            bank: [null, Validators.required],
            agency: [null, Validators.required],
            account: [null, Validators.required],
            digit: [null, Validators.required],
            born: [null, Validators.required],
            consultantStart: [null, Validators.required],
            cellPhone: [null, Validators.maxLength(20)],
            excellenceCenter: [null, [this.validateSelectOptionExcellenceCenter]],
            supportCenter: [null, null]
        });

        this.customers = await this.companyService.getAll();
        this.customers = _.orderBy(this.customers,[company => company.name.toUpperCase()]);
        this.customersDropdown.options = this.dropDownSettingFactory.build({text:'Clientes'});
        this.customersDropdown.list = this.dropDownItemFactory.build({source:this.customers});

        this.skills = await this.consultantService.getAllSkills();
        this.skillsDropdown.options = this.dropDownSettingFactory.build({text:'Skills'});
        this.skillsDropdown.list = this.dropDownItemFactory.build({source:this.skills});

        this.responsibles = await this.userService.getAllUsersAsResponsibles();
        this.bps = await this.userService.getAllUsersAsResponsibles();
        this.cnaes = await this.cnaeService.getAllItems([SapItemType.CnaeConsultant]);
        this.occupations = await this.consultantService.getAllContractProfile();
        this.banks = await this.bankService.getBanks();

        this.allCenters = await this.excellenceCentersService.getAll();

        this.excellenceCenters = this.allCenters.filter(center => center.type == 1 );
        this.excellenceCenters = _.orderBy(this.excellenceCenters, [sup => sup.name.toUpperCase()]);

        this.supportCenters = this.allCenters.filter(center => center.type == 2 );
        this.supportCenters = _.orderBy(this.supportCenters, [sup => sup.name.toUpperCase()]);

        this.consultant.payment.typePix = 0
        this.consultantForm.get("keyPix").disable();
        this.consultantForm.get("fcEmail").disable();
        this.loading = false;
    }

    validateSelectOptionResponsible(control: AbstractControl) {
        if (control.value === undefined || control.value == 'undefined')
            return {responsible: true};

        return null;
    }

    validateSelectOptionBP(control: AbstractControl) {
        if (control.value === undefined || control.value == 'undefined')
            return {bp: true};

        return null;
    }

    validateSelectOption(control: AbstractControl) {
        if (control.value == 0)
            return {contractKind: true};

        return null;
    }

    validateSelectOptionExcellenceCenter(control: AbstractControl) {
        if (control.value === '' || control.value == 'undefined')
            return {excellenceCenter: true};

        return null;
    }

    validateSelectOptionSupportCenter(control: AbstractControl) {
        if (control.value === '' || control.value == 'undefined')
            return {supportCenter: true};

        return null;
    }

    trim(){
        if(this.consultant.email)
            this.consultant.email = this.consultant.email.trim();
        if(this.consultant.fcEmail)
            this.consultant.fcEmail = this.consultant.fcEmail.trim();
        if(this.consultant.name)
            this.consultant.name = this.consultant.name.trim();
    }

    clear(){
        this.consultant = new Consultant();
        this.customersDropdown.selected = [];
        this.errors = [];
        this.uploadInput.nativeElement.value = '';
        this.skillsDropdown.selected = [];
    }

    async create() {
        this.consultantForm["submited"] = true;
        if (this.consultantForm.valid == false) {
            let errors = [];
            Object.keys(this.consultantForm.controls).forEach(control => {
                const controlErrors = this.consultantForm.get(control).errors
                if(controlErrors != null){
                    Object.keys(controlErrors).forEach(error =>{
                        let field = this.getVerboseField(control);
                        if(error == 'email'){
                            errors.push(`${field.verbose}: Formato de e-mail inválido`)
                        }

                        if(error == 'required' || error == 'responsible' || error == 'bank'
                        || error == 'contractKind' || error == 'excellenceCenter'){
                            errors.push(`Preencha o campo ${field.verbose}`)
                        }

                        if(error == 'maxlength'){
                            errors.push(`O campo ${field.verbose} ultrapassa o limite de caracteres`)
                        }

                    });
                }
            });
            this.errors = errors;
            return;
        }


        this.consultant.responsible.name = this.responsibles.find(x => x._id === this.consultant.responsible._id).name;
        this.consultant.bp.name = this.bps.find(x => x._id === this.consultant.bp._id).name;
        this.consultant.fcEmail = this.consultant.fcEmail.toLowerCase();
        this.consultant.name = this.consultant.name.trim();
        this.consultant.excellenceCenter = this.excellenceCenters.find(ec => ec._id == this.consultant.excellenceCenter._id);
        this.consultant.supportCenter = this.supportCenters.find(cs => cs._id == this.consultant.supportCenter._id) || {} as ExcellenceCenter;

        let customers = this.customersDropdown.selected.map(customer =>{
            return <any>{_id:customer.id,name:customer.itemName}
        });

        try {
            this.loading = true;
            let response = await this.consultantService.create(this.consultant);
            if(response._id){
                this.loading = false;
                this.toastr.success("Consultor cadastrado com sucesso!");

                if(this.selectedFiles)
                    this.upload(response._id);
                this.clear();
            } else {
                this.loading = false;
                this.toastr.warning(response._body);
            }
        } catch (err) {
            this.loading = false;
            this.router.navigate(['/consultants']);
            this.toastr.error("Erro ao cadastrar o consultor!");
        }

    }

    verifyValidTouched(fieldName) {

        let field = this.consultantForm.get(fieldName);
        return ((!field.valid && field.touched) || (!field.valid && this.consultantForm["submited"]));
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }

    changeExcellenceCenter() {
        if(this.consultant.excellenceCenter._id)
            this.consultant.excellenceCenter = this.excellenceCenters.find(ec => ec._id == this.consultant.excellenceCenter._id);
    };

    changeSupportCenter() {
        if(this.consultant.supportCenter._id)
            this.consultant.supportCenter = this.supportCenters.find(ec => ec._id == this.consultant.supportCenter._id);
    };

    changedContractType() {

        this.consultant.contract.mensalHours = 0;
        this.consultant.contract.soldHourValue = 0;
        this.consultant.contract.hourValue = 0;
        this.consultant.contract.totalValue = 0;

        this.consultant.contract.honorarium = 0;

        let kind = this.consultant.contract.kind;


        if (kind === ContractType.CLT) {
            this.consultant.contract.mensalHours = 168;
            this.consultant.contract.hourValue = this.consultantService.calculateHourValue(this.consultant);
            this.showTotalValue = true;
            this.showHourValueBenefits = true;
            this.showHourValue = true;
            this.disableHourValue = true;
            this.showMensalHours = true;
            this.showSoldHoursValue = true;
        }

        if (kind === ContractType.Estagiario || kind === ContractType.Outros) {
            this.showTotalValue = true;
            this.showMensalHours = true;
            this.showHourValueBenefits = false;
            this.showHourValue = true;
            this.disableHourValue = false;
        }

        if (kind === ContractType.PJ) {
            this.showTotalValue = false;
            this.showHourValue = false;
            this.showHourValueBenefits = false;
            this.showMensalHours = false;
            this.disableHourValue = false;
        }

    }

    changedHonorarium() {
        let honor = this.consultant.contract.honorarium;
        this.honorarium = true;
        this.showSoldHoursValue = true;

        if (honor === HonorariumType.HoraAberta) {
            this.showTotalValue = false;
            this.showHourValue = true;
            this.showHourValueBenefits = false;
            this.showMensalHours = false;
            this.disableHourValue = false;
        }

        if (honor === HonorariumType.HoraFechada) {
            this.consultant.contract.mensalHours = 168;
            this.consultant.contract.hourValue = this.consultantService.calculateHourValue(this.consultant);
            this.showTotalValue = true;
            this.showHourValue = true;
            this.showHourValueBenefits = false;
            this.disableHourValue = true;
            this.showMensalHours = true;
        }
    }

    getVerboseField(name){
        return _.find(this.commonHelper.getConsultantVerboseFields(),{name:name});
    }


    calculateHourValue() {
        let kind = this.consultant.contract.kind;
        let honor = this.consultant.contract.honorarium;

        if (kind === ContractType.CLT
            || (kind === ContractType.PJ && honor === HonorariumType.HoraFechada)) {
            this.consultant.contract.hourValue = this.consultantService.calculateHourValue(this.consultant);
            this.disableHourValue = true;
        } else {
            this.disableHourValue = false;
        }
    }

    async verifyEmail(){
        this.trim();
        if(!this.consultant.fcEmail)
            return this.toastr.warning("E-mail FCamara é obrigatório.");
        if(!this.consultant.personal.cpf)
            return this.toastr.warning("CPF é obrigatório");

        const response = await this.publicConsultantService.verifyIfEmailExists(this.consultant.fcEmail);
        if(response.error) {
            this.toastr.error(response.error.message);
            this.consultant.fcEmail = "";
        } else if(response.emailExists) {
            this.toastr.warning(`E-mail FC ${this.consultant.fcEmail} já está em uso!`);
            this.consultant.fcEmail = "";
        }
    }

    async verifyCPF(){
        const clearCpf = () => {
            this.consultant.personal.cpf = "";
            this.consultant.fcEmail = "";
            this.consultant.freshServiceId = "";
            this.disableFcEmail();
        }

        try {
            const cpf = this.consultant.personal.cpf;
            if(cpf == null || cpf == ""){
                clearCpf();
                return this.toastr.warning("O CPF é obrigatório!");
            }

            if(!(this.commonHelper.cpfValidator(cpf))){
                clearCpf();
                return this.toastr.warning("CPF inválido");
            }

            let responseCpfExists = await this.consultantService.verifyCPF(this.consultant);
            if(responseCpfExists.length > 0){
                clearCpf();
                return this.toastr.warning(`Este CPF é utilizado pelo consultor: ${responseCpfExists[0].name}`,"CFP já está em uso!");
            }

            let responseFreshService = await this.consultantService.getFreshServiceEmailByCPF(cpf);
            if(responseFreshService && responseFreshService.fcEmail) {
                this.consultant.fcEmail = responseFreshService.fcEmail;
                this.consultant.freshServiceId = responseFreshService.freshServiceId;
                this.verifyEmail();
            } else {
                this.toastr.warning('Erro ao resgatar FCEmail com base no CPF');
            }
            this.disableFcEmail();
        } catch(err) {
            this.consultant.fcEmail = "";
            this.consultant.freshServiceId = "";
            this.disableFcEmail();
            this.toastr.warning('Erro ao resgatar FCEmail com base no CPF');
        }
    }

    disableFcEmail(){
        const control = this.consultantForm.get('fcEmail');
        if(!this.consultant.personal.cpf)
            control.disable();
        else
            control.enable();
    }

    async verifyCPFCNPJPixKey(){
        if(this.consultant.payment.keyPix == null || this.consultant.payment.keyPix == ""){
            this.toastr.warning("O CPF/CNPJ é obrigatório!");
            this.consultant.payment.keyPix = "";
        } else if(this.commonHelper.cpfValidator(this.consultant.payment.keyPix)){
            this.pixCpfValid = true;
        } else if(this.companiesService.cnpjValid(this.consultant.payment.keyPix)){
          this.pixCnpjValid = true;
        }else if(!this.pixCnpjValid && !this.pixCpfValid){
          this.toastr.warning('CPF/CNPJ inválido.');
          this.consultant.payment.keyPix = "";
        }
      }

    cnpjValid(cnpj: String) {
        return this.consultantService.cnpjValid(cnpj);
    }

    async getCnpj(cnpj: String) {
        return await this.consultantService.getCnpj(cnpj);
    }

    randomPixKeySearch(){
        if(this.consultant.payment.keyPix == '' || this.consultant.payment.keyPix == undefined) {
            this.toastr.warning('Aleatório não pode ser vazio');
        } else if (!this.consultantService.randomPixKeyValid(this.consultant.payment.keyPix)) {
            this.toastr.warning('Aleatório inválido. Aleatório deve ter 36 caracteres!');
            this.consultant.payment.keyPix = ''
        }
    }

    async verifyEmailPixKey(){
        this.trim();

        if(this.consultant.payment.keyPix == null || this.consultant.payment.keyPix == ""){
         this.toastr.warning("O Email é obrigatório!");
         this.consultant.fcEmail = "";
        }else{
            if (!(new RegExp(this.emailPattern).test((this.consultant.payment.keyPix).toString()))) {
                this.toastr.warning(`Digite um email válido.`, "Email inválido!");
                this.consultant.payment.keyPix = "";
            }
        }
    }

    async cepSearch(){
        let cep = this.consultant.personal.cep;
        cep = cep.replace(/\-/g, "");
        if(cep == '' || cep.length != 8){
            this.toastr.warning('CEP inválido');
        } else {
            this.toastr.warning('Realizando consulta ao CEP...');
            let response = await this.consultantService.getCep(cep);
            this.consultant.personal.address = response.logradouro;
            this.consultant.personal.district = response.bairro;
            this.consultant.personal.city = response.localidade;
            this.consultant.personal.state = response.uf;
        }
    }

    async cnpjSearch(){
        if(this.consultant.contract.cnpj == ''){
            this.toastr.warning('CNPJ não pode ser vazio');
        } else {
            this.consultant.contract.cnpj = this.consultant.contract.cnpj.trim();
            this.toastr.warning('Realizando consulta ao CNPJ...');
            let response = await this.consultantService.getCnpj(this.consultant.contract.cnpj);
            if(response.status == 'ERROR'){
                this.toastr.warning(response.message);
            } else {
                this.consultant.contract.companyName = response.nome;
                this.consultant.contract.address = response.logradouro;
                this.consultant.contract.number = response.numero;
                this.consultant.contract.complement = response.complemento;
                this.consultant.contract.cep = response.cep;
                this.consultant.contract.district = response.bairro;
                this.consultant.contract.city = response.municipio;
                this.consultant.contract.state = response.uf;
            }
        }
    }

    changeCustomer(){
        if(this.consultant.contract.customers.length <= this.customersDropdown.selected.length){
            let diff = _.differenceWith(this.customersDropdown.selected, this.consultant.contract.customers, (a,b)=> a.id == b._id )
            this.consultant.contract.customers.push({
                _id:diff[0].id,
                name:diff[0].itemName
            })
        }
        else {
            let diff = _.differenceWith(this.consultant.contract.customers,this.customersDropdown.selected, (a,b)=> a._id == b.id )
            _.remove(this.consultant.contract.customers, item => item._id == diff[0]._id)
        }
    }

    changeSkill(){
        if(this.consultant.skills.length <= this.skillsDropdown.selected.length){
            let diff = _.differenceWith(this.skillsDropdown.selected, this.consultant.skills, (a,b)=> a.id == b._id )
            this.consultant.skills.push({
                _id:diff[0].id,
                name:diff[0].itemName
            })
        }
        else {
            let diff = _.differenceWith(this.consultant.skills,this.skillsDropdown.selected, (a,b)=> a._id == b.id )
            _.remove(this.consultant.skills, item => item._id == diff[0]._id)
        }
    }

    selectFile(event) {
        this.selectedFiles = event.target.files;
    }
    upload(id) {
        let length = this.selectedFiles.length;
        for(let i=0; i<length; i++){
            const file = this.selectedFiles.item(i);
            this.awsService.uploadfile(file,id);
        }
    }

    verifyDateContractStart(date,doc,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultant[`${doc}`][`${field}`] = "";
            this.consultant[`${doc}`][`end`] = "";
        } else {
            // let dateAux = moment(this.consultant.contract.begin, "DD/MM/YYYY").add(9,'months');
            // this.consultant.contract.end = moment(dateAux).format("DDMMYYYY");
        }
    }
    verifyDate(date,doc,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultant[`${doc}`][`${field}`] = "";
        }
    }
    verifyDate2(date,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultant[`${field}`] = "";
        }
    }

    changeCnae(){
        this.consultant.contract.sapServiceCode = this.cnaes.find(x => x.cnae === this.consultant.contract.cnae).sapItemCode;
    }

    openAddModalBank(){
        this.bankCode = null
        this.bankName = ""
        this.bankCountry = ""
    }

    async addBank(){
        try {
            const response = await this.bankService.postBank({
                name: this.bankName,
                countryCode: this.bankCountry.toUpperCase(),
                bankCode: this.bankCode
            });

            if(response._id) {
                this.banks = await this.bankService.getBanks();
                this.toastr.success('Banco criado com sucesso');
            }
        } catch(err) {
            console.log(err);
            this.toastr.error('Erro ao criar o banco');
        }
    }

    openEditBank(bank:any){
        this.bankForEdit.bankCode = bank.bankCode;
        this.bankForEdit.bankName = bank.name;
        this.bankForEdit.bankCountry = bank.countryCode;
        this.bankForEdit.bankSapCode = bank.sapCode;
    }

    async editBank(){
        try {
            let bankEdit = {
                "active": true,
                "bankCode": this.bankForEdit.bankCode,
                "name": this.bankForEdit.bankName,
                "countryCode": this.bankForEdit.bankCountry.toUpperCase(),
                "sapCode": this.bankForEdit.bankSapCode,
            }

            const response = await await this.bankService.updateBank(bankEdit);
            if(response._id) {
                this.banks = await this.bankService.getBanks();
                this.toastr.success('Banco atualizado com sucesso');
            }
        } catch(err) {
            console.log(err);
            this.toastr.error('Erro ao atualizar o banco');
        }
    }

    openDeleteBank(bank:any){
        this.bankCode = bank.bankCode;
    }

    async removeBank() {
        try {
            const response = await this.bankService.removeBank(this.bankCode);
            if(response.message == 'Deleted') {
                this.banks = await this.bankService.getBanks();
                this.toastr.success('Banco excluído com sucesso');
            }
        } catch(err) {
            console.log(err);
            this.toastr.error('Erro ao excluir o banco');
        }
    }

    onPixTypeChange() {
        this.pixValidation.onPixTypeChange(this.consultant.payment.typePix, this.consultantForm.get("keyPix"))
        this.textMask = {mask: false}
    }

    async verifyPixKey(){
        if (!this.consultant.payment.typePix) {
            return
        }
        this.pixCpfValid = false;
        this.pixCnpjValid = false;

        let typePix = this.consultant.payment.typePix

        switch (typePix) {
            case PixKeyType.phone:
                if(!this.commonHelper.phoneNumberValidator(this.consultant.payment.keyPix)){
                    this.toastr.warning('CPF/CNPJ inválido.');
                    this.consultant.payment.keyPix = "";
                }
                break;
            case PixKeyType.email:
                this.verifyEmailPixKey();
                break;
            case PixKeyType.cpf_cnpj:
                this.verifyCPFCNPJPixKey();
                break;
            case PixKeyType.randomized:
                this.randomPixKeySearch();
                break;
            default:
                break;
        }
    }

    onChangeMask() {
        let typePix = this.consultant.payment.typePix;
        switch (typePix) {
            case PixKeyType.phone:
                this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.phone)
                break;
            case PixKeyType.cpf_cnpj:
                let inputValue = this.consultant.payment.keyPix;
                if(!inputValue) return;

                if (inputValue && inputValue.length > 14)
                    this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, true);
                else
                    this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, false);
                break;
            case PixKeyType.randomized:
                this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.randomized)
                break;
            default:
                break;
        }
    }

    validateKeyPix(control: AbstractControl){
        if(!control.value)
            return {keyPix:true}
        return null;
    }

    calculateHourValueBenefits() {
        let kind = this.consultant.contract.kind;
        let honor = this.consultant.contract.honorarium;

        if (kind === ContractType.CLT
            || (kind === ContractType.PJ && honor === HonorariumType.HoraFechada)) {
            this.consultant.contract.hourValueBenefits = this.consultantService.calculateHourValueBenefits(this.consultant);
            this.disableHourValue = true;
        } else {
            this.disableHourValue = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/consultants/consultant-create/consultant-create.component.ts